export default __webpack_public_path__ + "CircularCustCapNum-BlackItalic.390e0ef7cabb8a9b8b1aab8c1ed0a56d.woff2";